import { FormControl } from 'baseui/form-control'
import { formControlOverrides } from '../styled-components'
import type { ReactNode } from 'react'

type SDFormControlProps = {
  hidden?: boolean
  children: ReactNode
  [key: string]: any
}

const SDFormControl = ({ hidden, children, ...props }: SDFormControlProps) => {
  if (hidden) return null

  return (
    // @ts-ignore
    <FormControl overrides={formControlOverrides} {...props}>
      {children}
    </FormControl>
  )
}

export default SDFormControl
